import { Group } from "@mantine/core";
import { IconBulb } from "@tabler/icons-react";
import ReactMarkdown from "react-markdown";
import { MarkdownLink } from "../../../ReactMarkdown/MarkdownLink";

interface FormFieldInfoTextProps {
  infoText: string;
}

function FormFieldInfoText({ infoText }: FormFieldInfoTextProps) {
  return (
    <Group wrap="nowrap">
      <IconBulb color="var(--mantine-primary-color-filled)" />
      <ReactMarkdown
        components={{
          a: MarkdownLink
        }}
      >
        {infoText}
      </ReactMarkdown>
    </Group>
  );
}

export { FormFieldInfoText };
